import styled from 'styled-components';


export const Wrapper = styled.div`
background-color: #E5D8DA;
padding: 1rem;
width: fit-content;
position:fixed;
top:0;
right:0;

&:hover {
  cursor: pointer;
}

`;

export const LogoutIcon = styled.img`
width: 2rem;
`